import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { updatePhotographerProfile, uploadProfileImage } from "../../services/authService";
import "./UserProfile.css";

/* helper – shrink image before upload */
async function shrinkImage(
  file,
  { maxW = 600, maxH = 600, mime = "image/jpeg", quality = 0.8 } = {}
) {
  const bmp = await createImageBitmap(file);
  let { width: w, height: h } = bmp;
  if (w > maxW || h > maxH) {
    const ratio = Math.min(maxW / w, maxH / h);
    w = Math.round(w * ratio); h = Math.round(h * ratio);
  }
  const canvas = new OffscreenCanvas(w, h);
  canvas.getContext("2d").drawImage(bmp, 0, 0, w, h);
  const blob = await canvas.convertToBlob({ type: mime, quality });
  return await new Promise((res) => {
    const fr = new FileReader(); fr.onloadend = () => res(fr.result); fr.readAsDataURL(blob);
  });
}

export default function UserProfile() {
  const history   = useHistory();
  const { state } = useLocation();
  const userData  = state?.userData || null;
  const to_update = state?.to_update ?? true;

  const [user, setUser] = useState(() => ({
    username: userData?.username || "",
    phone   : userData?.phone    || "",
  }));
  const [profile, setProfile] = useState(() =>
    userData?.photographer_profile || {
      email: "", instagram: "", facebook: "", whatsapp: "", image_url: "",
    }
  );
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  if (!userData)
    return <div className="user-profile">אין נתוני משתמש – התחבר ואז נסה שוב.</div>;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "username" || name === "phone")
      setUser((prev) => ({ ...prev, [name]: value }));
    else
      setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    const res = await updatePhotographerProfile(userData.user_id, {
      user_id: userData.user_id,
      username: user.username,
      phone: user.phone,
      photographer_profile: profile,
    });
    setMsg(res.success ? "הפרטים נשמרו בהצלחה" : res.message || "שגיאה בשמירת הפרטים");
    setSaving(false);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const compressed = await shrinkImage(file);
      const res = await uploadProfileImage(userData.user_id, compressed);
      if (res.success) {
        setProfile((p) => ({ ...p, image_url: res.image_url }));
        setMsg("התמונה עודכנה בהצלחה");
      } else setMsg(res.message || "שגיאה בהעלאת התמונה");
    } catch (err) {
      console.error(err);
      setMsg("❌ כשל בהעלאת תמונה");
    }
  };

  return (
    <div className="user-profile">
      <button className="close-btn" onClick={() => history.goBack()}>×</button>
      <div className="user-details-title">פרטי צלם</div>
      {msg && <div className="status-msg">{msg}</div>}

      {to_update ? (
        <div className="user-details-content">

          {/* Image and upload button */}
          <div className="image-wrapper">
            {profile.image_url ? (
              <img src={profile.image_url} alt="Profile" className="profile-image" />
            ) : (
              <div className="profile-image" style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0f0f0",
                color: "#888"
              }}>
                ללא תמונה
              </div>
            )}

            <label  htmlFor="profile-upload" className="upload-image-label">
            <img src="/icons/upload.png" alt="Upload" className="upload-icon" />

            </label >
            <input id="profile-upload" type="file" accept="image/*" onChange={handleImageUpload} />
          </div>

          <div className="form-fields">
            <label>שם משתמש:
              <input name="username" value={user.username} onChange={handleChange} />
            </label>
            <label>טלפון:
              <input name="phone" value={user.phone} onChange={handleChange} />
            </label>
            <label>מייל:
              <input name="email" type="email" value={profile.email} onChange={handleChange} />
            </label>
            <label>אינסטגרם:
              <input name="instagram" value={profile.instagram} onChange={handleChange} />
            </label>
            <label>פייסבוק:
              <input name="facebook" value={profile.facebook} onChange={handleChange} />
            </label>
            <label>וואטסאפ:
              <input name="whatsapp" value={profile.whatsapp} onChange={handleChange} />
            </label>
          </div>


          <button className="circular-button save-profile" onClick={handleSave} disabled={saving}>
            {saving ? "שומר…" : "שמור שינויים"}
          </button>
        </div>
      ) : (
        <div className="user-profile-view">
          {profile.image_url && (
            <img src={profile.image_url} alt="Profile" className="profile-image" />
          )}
          <div className="username">{user.username}</div>
          <p className="contact-info">
            {user.phone && <>📞 <a href={`tel:${user.phone}`}>{user.phone}</a><br /></>}
            {profile.email && <>📧 <a href={`mailto:${profile.email}`}>{profile.email}</a><br /></>}
          </p>
          <div className="social-icons">
            {profile.instagram && (
              <a href={`https://instagram.com/${profile.instagram}`} target="_blank" rel="noopener noreferrer">
                <img src="/icons/instagram.png" alt="Instagram" className="icon" />
              </a>
            )}
            {profile.facebook && (
              <a href={profile.facebook.startsWith("http") ? profile.facebook : `https://${profile.facebook}`}
                 target="_blank" rel="noopener noreferrer">
                <img src="/icons/facebook.png" alt="Facebook" className="icon" />
              </a>
            )}
            {user.phone && (
              <a href={`https://wa.me/${user.phone}`} target="_blank" rel="noopener noreferrer">
                <img src="/icons/whatsapp.png" alt="WhatsApp" className="icon" />
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
